import { t } from '@/i18n'
import { computed } from 'vue'
export enum ProjectRole {
  REVIEWER = 'reviewer',
  MANAGER = 'manager',
  EDITOR = 'editor'
}

export const ProjectRoleMap = {
  [ProjectRole.REVIEWER]: computed(() => t('enum.reviewer')),
  [ProjectRole.MANAGER]: computed(() => t('enum.admin')),
  [ProjectRole.EDITOR]: computed(() => t('enum.editor')),
}

export enum RoleType {
  COLLABORATOR = 'collaborator',
  ADMINISTRATOR = 'manager',
  OWNER = 'owner'
}

export const RoleTypeLabelMap = {
  [RoleType.ADMINISTRATOR]: computed(() => t('enum.admin')),
  [RoleType.COLLABORATOR]: computed(() => t('enum.collaborator')),
  [RoleType.OWNER]: computed(() => t('enum.owner'))
}